import { FC } from "react";
import classNames from "classnames";
import { useDispatch} from "react-redux";

import { upgradeSubscription } from "../../store/auth/slice";
import { PlanFeatureBlurGateProps } from "./types";
import Button from "../Button";

import styles from "./PlanFeatureBlurGate.module.css";



const PlanFeatureBlurGate: FC<PlanFeatureBlurGateProps> = ({
  children,
  isLocked,
  showUpgradeButton = true,
  className,
}) => {
  const dispatch = useDispatch();

  const handleUpgrade = () => {
    dispatch(upgradeSubscription());
  };

  if (!isLocked) return <>{children}</>;

  return (
    <div className={classNames(styles["plan-gate"], className)}>
      <div className={styles["plan-gate__overlay"]}>
        {showUpgradeButton && 
          <Button 
            className={styles["plan-gate__btn"]} 
            typeStyle="fill"  
            onClick={handleUpgrade}
            label="Upgrade Plan"
          />
        }
      </div>
      {children}
    </div>
  );
};

export default PlanFeatureBlurGate;
